import { FC, HTMLAttributes } from 'react'
import styled from 'styled-components'
import { updateColorOpacity } from 'utils/colorHelpers'

export const PIN_SIZE = '25px'
export const MarkerPinIcon: FC<
  {
    backgroundColor: string
    borderColor: string
  } & HTMLAttributes<HTMLDivElement>
> = ({ backgroundColor, borderColor, ...divProps }) => {
  return (
    <PinContainer>
      <StyledPinIcon
        $backgroundColor={backgroundColor}
        $borderColor={borderColor}
        {...divProps}
      />
      <PinShadow $backgroundColor={borderColor} />
    </PinContainer>
  )
}

const PinContainer = styled.div`
  position: relative;
  height: ${PIN_SIZE};
  width: ${PIN_SIZE};
`

const StyledPinIcon = styled.div<{
  $backgroundColor: string
  $borderColor: string
}>`
  background: ${({ $backgroundColor }) => $backgroundColor};

  position: relative;
  width: ${PIN_SIZE};
  height: ${PIN_SIZE};
  border-radius: 50% 50% 50% 0;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  transform: rotate(-45deg);
  z-index: 2;

  // Center dot
  &::after {
    content: '';
    position: absolute;
    height: 45%;
    aspect-ratio: 1 / 1;
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    z-index: 2;
  }
`

const PinShadow = styled.div<{ $backgroundColor: string }>`
  position: absolute;
  width: ${PIN_SIZE};
  height: calc(${PIN_SIZE} * 0.33);

  background: radial-gradient(
    ${({ $backgroundColor }) =>
      `circle at center, ${updateColorOpacity($backgroundColor, 0.75)}, ${updateColorOpacity($backgroundColor, 0)}`}
  );
  border-radius: 50%;
  top: 100%;
  z-index: 1;
`
